import { Tooltip, Typography } from 'antd'

/**
 * Doiradan tashqaridagi ko'rsatkich — chiziqcha va sababi.
 *
 * ⚠️ NOL EMAS. Backend ko'rinmaydigan metrikani `null` qaytaradi
 * (`DashboardSummary` javadoc'i) va uni `0` qilib chizish AGENT roli
 * bilan kirgan odamga "tashkilotda abonent yo'q, bugun sotuv bo'lmagan"
 * degan yolg'on ko'rsatardi.
 *
 * ⚠️ UMUMIY komponent, sahifaniki emas: bitta `GET /api/reports/dashboard`
 * javobi ikki ekranda (bosh sahifa va «Hisobotlar») chiziladi va ular
 * `null` ni har xil o'qiganda bir xil foydalanuvchi bir joyda «—», ikkinchi
 * joyda «0» ko'rardi.
 */
export function ScopeHidden({ hint }: { hint: string }) {
  return (
    <Tooltip title={hint}>
      <Typography.Text type="secondary">—</Typography.Text>
    </Tooltip>
  )
}
